// Which browser this is, for advice when it cannot keep a folder open (the File System Access API).

/** Brave turns the API off; Firefox, Safari and phones do not have it. */
export type FolderBrowser = 'brave' | 'firefox' | 'safari' | 'phone' | 'other';

export function folderBrowser(userAgent = navigator.userAgent, brave = 'brave' in navigator): FolderBrowser {
  if (/Android|iPhone|iPad|iPod|Mobile/.test(userAgent)) return 'phone';
  if (brave) return 'brave';
  if (/Firefox\//.test(userAgent)) return 'firefox';
  if (/Safari\//.test(userAgent) && !/(Chrome|Chromium|Edg)\//.test(userAgent)) return 'safari';
  return 'other';
}

/** The flag that turns folder access on in Brave. */
export const BRAVE_FLAG = 'brave://flags/#file-system-access-api';
